import http from '../../../plugins/axios';

export default {

    addMarket(data) {
        return http.post({
            url: 'admin/market/maker/add',
            data,
            dataType: 'form'
        })
    },

    updateMarket(data) {
        return http.post({
            url: 'admin/market/maker/update',
            data,
            dataType: 'form'
        })
    },

    updateStatus(data){
        return http.post({
            url: 'admin/market/maker/status',
            data,
            dataType: 'form'
        })
    },

    getMarketList(data) {
        return http.get({
            url: 'admin/market/maker/list',
            data
        })
    },
}
